import transform from 'lodash/transform';
import set from 'lodash/set';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

import isArray from 'lodash/fp/isArray';
import isObjectLike from 'lodash/fp/isObjectLike';
import isPlainObject from 'lodash/fp/isPlainObject';
import map from 'lodash/fp/map';

function createIteratee(converter: Function, self: Function) {
    return (result: any, value: any, key: string) => set(result, converter(key), isObjectLike(value) ? self(value) : value);
}

export function createTransformer(keyConverter: Function) {
    return function humps(node: Function): any {
        if (isArray(node)) {
            return map(humps, node);
        }
        if (isPlainObject(node)) {
            return transform(node, createIteratee(keyConverter, humps));
        }
        return node;
    };
}

export function camelCaseObject(obj: any) {
    return createTransformer(camelCase)(obj);
}

export function snakeCaseObject(obj: any) {
    return createTransformer(snakeCase)(obj);
}
